var _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBed = function SvgBed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("path", {
    id: "Union_159",
    "data-name": "Union 159",
    d: "M12.6,11.3V10q-.05,0-.1,0H1.5q-.051,0-.1,0v1.3a.7.7,0,1,1-1.4,0V.7A.7.7,0,1,1,1.4.7V7q.05,0,.1,0h11q.05,0,.1,0V3.7a.7.7,0,1,1,1.4,0v7.6a.7.7,0,1,1-1.4,0ZM5.4,6a.5.5,0,1,1,0-1h6a.5.5,0,0,1,0,1ZM2.6,6a.5.5,0,1,1,0-1H3.7a.5.5,0,1,1,0,1Z",
    fill: "#fff"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bed.dd900541.svg";
export { ForwardRef as ReactComponent };